import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import Selectors from '../selectors'

const mapStateToProps = createStructuredSelector({
  collectionIsPrivate: Selectors.getIsCollectionPrivate,
  hasInitialLoad: Selectors.getHasInitialLoad,
  hasValidPermissions: Selectors.getHasValidPermissions,
  name: Selectors.getCollectionOwnerName,
  ownerId: Selectors.getOwnerId,
})

export type ConnectorProps = {
  collectionIsPrivate: boolean
  hasInitialLoad: boolean
  hasValidPermissions: boolean
  name: string
  ownerId: string
}
export default connect(mapStateToProps)
